import { Config } from "shared/models/Config";
import { ConfigDto } from "./api/ConfigDto";
import { FeatureFlagsFromResponse } from "./FeatureFlagsFromResponse";

export class ConfigFromResponse {
    constructor(private configFromResponse: ConfigDto) {}

    config(): Config {
        return {
            production: process.env.REACT_APP_USE_LOCAL_TEAMS === "true" || this.configFromResponse.production,
            // TODO Remove this const when API will be ready - EHTA-238
            fileSizeLimit: this.configFromResponse.fileSizeLimit || 1048576,
            featureFlags: new FeatureFlagsFromResponse(this.configFromResponse.featureFlags).flags()
        };
    }
}